import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcSatisfied = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.0002,
			cy: 10.0002,
			r: 7.85714,
			fill: "#89B0FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.65331 10.3827C6.83645 10.3094 7.04429 10.3985 7.11755 10.5816L6.78595 10.7143C7.11755 10.5816 7.11762 10.5818 7.11755 10.5816L7.11727 10.5809L7.12067 10.5887C7.1245 10.5972 7.13119 10.6117 7.14096 10.6313C7.16054 10.6704 7.19237 10.7296 7.23834 10.8022C7.33045 10.9476 7.47804 11.1449 7.69583 11.3429C8.12561 11.7336 8.84491 12.1428 10.0002 12.1428C11.1556 12.1428 11.8749 11.7336 12.3046 11.3429C12.5224 11.1449 12.67 10.9476 12.7621 10.8022C12.8081 10.7296 12.8399 10.6704 12.8595 10.6313C12.8693 10.6117 12.876 10.5972 12.8798 10.5887L12.8834 10.5804C12.8837 10.5798 12.8835 10.5802 12.8834 10.5804C12.9569 10.3977 13.1642 10.3095 13.3472 10.3827C13.5303 10.4559 13.6194 10.6638 13.5461 10.8469L13.2145 10.7143C13.5461 10.8469 13.5462 10.8467 13.5461 10.8469L13.5454 10.8488L13.5443 10.8514L13.5414 10.8584C13.539 10.8639 13.5359 10.8712 13.532 10.88C13.5241 10.8976 13.513 10.9214 13.4984 10.9507C13.4691 11.0092 13.4256 11.0895 13.3656 11.1844C13.2456 11.3737 13.0584 11.6229 12.7851 11.8714C12.2328 12.3735 11.3449 12.8571 10.0002 12.8571C8.65556 12.8571 7.76772 12.3735 7.21535 11.8714C6.94207 11.6229 6.75484 11.3737 6.6349 11.1844C6.57484 11.0895 6.53134 11.0092 6.50209 10.9507C6.48745 10.9214 6.47634 10.8976 6.46849 10.88C6.46456 10.8712 6.46144 10.8639 6.4591 10.8584L6.45616 10.8514L6.45511 10.8488L6.4547 10.8478C6.45461 10.8476 6.45435 10.8469 6.78595 10.7143L6.45435 10.8469C6.3811 10.6638 6.47017 10.4559 6.65331 10.3827Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.85735,
			cy: 8.57122,
			r: .714286,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.143,
			cy: 8.57122,
			r: .714286,
			fill: "white"
		})
	]
});
export default SvgIcSatisfied;
